import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { BookOpen, Mic } from "lucide-react";

export const Book = () => {
  return (
    <section className="py-20 px-4 bg-muted/50">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-6">
            Sharing the Story
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Beyond the documentary, this powerful story of hope and reunion will reach even more hearts
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Card className="h-full border-story-hope/20 hover:border-story-hope/40 transition-colors">
              <CardHeader className="text-center">
                <div className="w-16 h-16 bg-story-hope/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <BookOpen className="w-8 h-8 text-story-hope" />
                </div>
                <CardTitle className="text-2xl font-serif">Upcoming Book</CardTitle>
                <CardDescription className="text-lg">
                  Coming Soon
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  The complete story of this extraordinary 26-year journey will be available in book form, 
                  offering deeper insights into the refugee experience, the power of human connection, 
                  and the healing that comes from reuniting with those who changed our lives.
                </p>
                <Button 
                  variant="outline" 
                  className="border-story-hope text-story-hope hover:bg-story-hope hover:text-background"
                >
                  Get Notified
                </Button>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <Card className="h-full border-story-peace/20 hover:border-story-peace/40 transition-colors">
              <CardHeader className="text-center">
                <div className="w-16 h-16 bg-story-peace/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mic className="w-8 h-8 text-story-peace" />
                </div>
                <CardTitle className="text-2xl font-serif">Speaking Journey</CardTitle>
                <CardDescription className="text-lg">
                  Future Aspirations
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  This story has the power to inspire global audiences. The dream is to share this message 
                  of hope, resilience, and human connection on the world's biggest stages, including a future TED talk 
                  that could touch millions of lives.
                </p>
                <Button 
                  variant="outline"
                  className="border-story-peace text-story-peace hover:bg-story-peace hover:text-background"
                >
                  Speaking Inquiries
                </Button>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
};